// Beräknar ålder från ett ISO-datum (YYYY-MM-DD). Returnerar null om
// datumet är ogiltigt eller i framtiden.

export function ageFromBirthday(birthday: string | undefined | null): number | null {
  if (!birthday) return null;
  const birth = new Date(birthday);
  if (Number.isNaN(birth.getTime())) return null;
  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const m = today.getMonth() - birth.getMonth();
  // Justera om vi inte fyllt år ännu i år
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age -= 1;
  }
  if (age < 0 || age > 150) return null;
  return age;
}
